import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import BreadcrumbComponent from "@atoms/breadcrumbs/breadcrumb.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import { getSettingFormInputs } from "../model/settings.modal";
import { editSettingApi } from "../setting-edit/setting.edit.service";
import MESSAGES from "@constants/messages.constants";
import ToolTipComponent from "@atoms/tooltip/tooltip.component";

const {
  SETTINGS_ALERTS: { EDIT_ALERT },
} = MESSAGES;

function SettingListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableActions,
  },
  templateEvents: {
    getSettingsData,
    handleCreateClick,
    deleteRecords,
    submitFilter,
    handleDownload,
  },
}) {
  const settingFormEdit = `${breadCrumbs[1].menu_url}/edit`;

  // console.log({ filters });

  const ActionContent = ({ handleCreateClick }) => {
    return (
      <>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleCreateClick}
        >
          <FeatherIcon icon="plus" size={17} />
        </button>
        &nbsp;&nbsp;
        <ToolTipComponent content={"Log Download"}>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={handleDownload}
          >
            <FeatherIcon icon="download" size={17} />
          </button>
        </ToolTipComponent>
      </>
    );
  };

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"All Settings"}
        breadCrumbs={breadCrumbs}
        actionContent={<ActionContent handleCreateClick={handleCreateClick} />}
      />
      <DataGridComponent
        title={tableTitle}
        keyColumn={keyColumn}
        tableData={tableData}
        tableColumn={tableColumn}
        totalCount={totalCount}
        dataRefresh={getSettingsData}
        editLink={settingFormEdit}
        deleteRecords={deleteRecords}
        breadCrumbs={breadCrumbs}
        filters={filters}
        submitFilter={submitFilter}
        tableActions={tableActions}
        editModal={{
          getInputs: getSettingFormInputs,
          editApi: editSettingApi,
          EDIT_ALERT,
        }}
      />
    </PageWrapperComponent>
  );
}

export default SettingListTemplateComponent;

// {/* <DataGridComponent
//   title={tableTitle}
//   keyColumn={keyColumn}
//   tableData={tableData}
//   tableColumn={tableColumn}
//   totalCount={totalCount}
//   dataRefresh={getSettingsData}
//   editLink={settingFormEdit}
//   breadCrumbs={breadCrumbs}
// />
